import React from 'react';
import { convertToRelativeUrl } from '@benzinga/utils';

interface ArticleLinkWrapperProps {
  article: {
    url?: string;
    nodeId: number;
  };
  className?: string;
  children: React.ReactNode;
}

export const ArticleLinkWrapper = ({ article, className, children }: ArticleLinkWrapperProps) => {
  const href = convertToRelativeUrl(article?.url || `/article/${article.nodeId}`);
  return (
    <a href={href} className={className}>
      {children}
    </a>
  );
};
